import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import styles from '../../styles/UserProfile.module.css';
import { useSession, signOut } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useTheme } from "next-themes";
import { Avatar, Button, Divider, Tag, Typography } from "antd";
import $ from 'jquery'
import ApiUrl from '../../url.json';
Modal.setAppElement('#__next');
import StdManageWidget from "../widgets/StdManageWidget";
import { useQueryClient } from "@tanstack/react-query";

const UserProfileModal = ({ isOpen, onRequestClose }) => {

  //* code for theme */
  const { theme, setTheme } = useTheme();
  useEffect(() => {
    const getSystemTheme = async () => { };
    getSystemTheme();
  }, [setTheme, theme]);
  //* code for theme */

  const { data: session } = useSession();
  const [showWidget, setShowWidget] = useState(false);
  const [showDetails, setShowDetails] = useState({ "userName": "Empty" });
  const router = useRouter();
  const [refreshGenericTable, setRefreshGenericTable] = useState(false);
  const queryClient = useQueryClient();
  const triggerGenericRefresh = () => {
    setRefreshGenericTable((prev) => !prev);
  };
  useEffect(() => {
    fetchUserDetails();
  }, [])

  const handleSignOut = async () => {
    localStorage.clear();
    document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    await signOut({ redirect: false });
    router.push('/');
    queryClient.clear();
  };

  const fetchUserDetails = () => {
    let userId = localStorage['_id']
    $.ajax({
      type: "GET",
      url:
        ApiUrl.newUrl +
        "/api/dbjsonschema/getPackageInfo/Users" +
        "/" +
        userId,
      dataType: "json",
      async: false,
      headers: { jwt: localStorage.getItem("jwt") },
      success: function (result) {
        if (result) {
          // console.log(result);
          setShowDetails(result.data[0]);
          // console.log('User details fetched sucessfully');
        }
      }, error: function (XMLHttpRequest, textStatus, errorThrown) {
        console.error("Error fetching UserDetails:", textStatus, errorThrown);
      }
    });
  }

  // console.log(showDetails._id);


  const handleEditProfile = () => {
    setShowWidget(true);
    if (onRequestClose) {
      onRequestClose();
    }
  };

  const getLocalValue = (key) => {
    if (typeof window === "undefined") return "";
    return localStorage.getItem(key) || "";
  };

  const userName = getLocalValue("name") || showDetails?.Name || showDetails?.userName || session?.user?.name || "User";
  const userEmail = getLocalValue("userId") || showDetails?.Email || showDetails?.email || session?.user?.email || "Not available";
  const userCompany = getLocalValue("company") || showDetails?.Company || showDetails?.company || "Not available";
  const userRole = getLocalValue("roles") || showDetails?.Role || showDetails?.role || "Not available";

  const userInitials = (userName || "U")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((name) => name[0]?.toUpperCase())
    .join("");

  // {open1 && <StdManageWidget open1={open1} setOpen1={setOpen1} 
  // setShowWidget={setShowWidget} mode="edit" currentSchemaName="Users" 
  // currentItemID={showDetails.userName ? '' : localStorage['_id']} currentTitleName="User" />}


  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="User Profile Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 5000,
          }
        }}
        className={styles.userProfileModalCard}
      >
        {session ? (
          <div className={styles.profileShell}>
            <button className={styles.onRequestClose} onClick={onRequestClose}>
              <span>&times;</span>
            </button>
            <div className={styles.profileHeaderNew}>
              <Avatar className={styles.profileAvatar} size={56}>
                {userInitials}
              </Avatar>
              <div className={styles.profileHeaderText}>
                <Typography.Title level={4} className={styles.profileTitle}>
                  {userName}
                </Typography.Title>
                <Typography.Text className={styles.profileSubtitle}>
                  {userEmail}
                </Typography.Text>
              </div>
            </div>


            <div className={styles.profileInfoGrid}>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Name</span>
                <span className={styles.infoValue}>{userName}</span>
              </div>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Email</span>
                <span className={styles.infoValue}>{userEmail}</span>
              </div>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Company</span>
                <span className={styles.infoValue}>{userCompany}</span>
              </div>
              <div className={styles.infoTile}>
                <span className={styles.infoLabel}>Role</span>
                <span className={styles.infoValue}>{userRole}</span>
              </div>
            </div>

            <Divider className={styles.profileDivider} />
            <div className={styles.buttonGroup}>
              <Button className={styles.editProfileBtn} onClick={handleEditProfile}>
                Edit Profile
              </Button>
              <Button danger className={styles.signOutBtnNew} onClick={handleSignOut}>
                Sign Out
              </Button>
            </div>
          </div>
        ) : (
          <p>Please log in</p>
        )}
      </Modal>
      {/* {open1 && <StdManageWidget open1={open1} setShowWidget={setOpen1} */}
      {/* mode="Edit" currentSchemaName="Users"
        currentItemID={showDetails['_id']} currentTitleName="User" userEditProfile="userEditProfile" />} */}

      {showWidget && <StdManageWidget open1={showWidget} setShowWidget={setShowWidget}
        mode="Edit" currentSchemaName="Users"
        currentItemID={showDetails['_id']} currentTitleName="User" userEditProfile="userEditProfile" onRefresh={triggerGenericRefresh} />}

    </>
  );

};

export default UserProfileModal;
